export default __webpack_public_path__ + "static/case-study1-01b547fa48a814fb6e312d4d4905b628.png";